import { storageGet } from '../libs/localStorage';

export default () => {
  const basketItems = storageGet('basketItems');

  if (basketItems) {
    const basketItemsKeys = Object.keys(basketItems);
    const itemsForDiginetica = {};

    for (let i = 0; i < basketItemsKeys.length; i++) {
      const { PRODUCT_ID, AMOUNT, FROM_SET } = basketItems[basketItemsKeys[i]];

      if (!FROM_SET) {
        if (itemsForDiginetica[PRODUCT_ID]) itemsForDiginetica[PRODUCT_ID] += AMOUNT;
        else itemsForDiginetica[PRODUCT_ID] = AMOUNT;
      }
    }

    return itemsForDiginetica;
  }

  return {};
};
